import React from 'react';
import { services } from '../../data/mock';

export const ServicesSection = () => (
  <section className="valuare-section" id="servicos" data-testid="services-section">
    <div className="valuare-section-content">
      <div className="valuare-section-label">Serviços Especializados</div>
      <h2 className="valuare-section-title">
        Avaliações Técnicas<br /><em>Certificadas</em> EVS / TEGoVA
      </h2>
      <div className="valuare-services-grid">
        {services.map((service) => (
          <div key={service.id} className="valuare-service-card">
            <div className="valuare-service-num">{service.number}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
